export default() => {
  const supportMouse = 'onmouseup' in document;
  const CLICK_OR_TOUCH_EVENT = supportMouse ? 'click' : 'touchend';

  // 設問選択肢クリックイベント(PC)
  const clickOption = e => {
    const optionEl = e.currentTarget;
    const questionEl = optionEl.parentNode;
    if(questionEl.classList.contains('fadeout')) return;

    const qNo = questionEl.dataset.qno;
    const wheelEl = questionEl.getElementsByClassName('wheel')[0];
    let meterNo = '0';

    const switchSlide = ($className) => {
      const answerEl = questionEl.parentNode.getElementsByClassName($className)[0];
      answerEl.classList.add('active');

      setTimeout(() => {
        questionEl.classList.add('fadeout');
      }, 1500);

      setTimeout(() => {
        questionEl.style.display = 'none';

        meterNo = answerEl.dataset.meter;
        if (meterNo) {
          const questionElList = document.getElementById('stories').getElementsByClassName('visible_pc')[0].getElementsByClassName('question');
          for (var i = qNo; i < questionElList.length; i++) {
            if (!questionElList[i].classList.contains('fadeout')) {
              const meterImg = questionElList[i].getElementsByClassName('meter')[0].firstElementChild;
              meterImg.setAttribute('src', `img/stories/meter_${meterNo}.png`);
              meterImg.setAttribute('alt', `興奮度${meterNo}%`);
            }
          }
        }
        if (qNo == '5') {
          // 最終設問のみ
          const recruitBtn = document.getElementById('recruit').getElementsByClassName('btn-accordion')[0];
          if (!recruitBtn.classList.contains('open')) {
            recruitBtn.classList.add('open');
            recruitBtn.nextElementSibling.classList.add('open');
          }
        }
      }, 3500);
    };

    if (optionEl.classList.contains('left')) {
      wheelEl.classList.add('to-left');
      switchSlide('answer-a');
    } else if (optionEl.classList.contains('right')) {
      wheelEl.classList.add('to-right');
      switchSlide('answer-b');
    } else {
      console.log('sorry, click again');
    }
  };

  // 設問選択肢クリックイベント(SP)
  const clickOptionSp = e => {
    const optionEl = e.currentTarget;
    const questionEl = optionEl.parentNode.parentNode;
    if(questionEl.classList.contains('fadeout')) return;

    const qNo = questionEl.dataset.qno;
    let meterNo = '0';

    const switchSlide = ($className) => {
      const answerEl = questionEl.parentNode.getElementsByClassName($className)[0];
      answerEl.classList.add('active');
      questionEl.classList.add('fadeout');

      setTimeout(() => {
        questionEl.style.display = 'none';
        meterNo = answerEl.dataset.meter;
        if (meterNo) {
          const questionElList = document.getElementById('stories').getElementsByClassName('visible_sp')[0].getElementsByClassName('question');
          for (var i = qNo; i < questionElList.length; i++) {
            if (!questionElList[i].classList.contains('fadeout')) {
              const meterImg = questionElList[i].getElementsByClassName('meter')[0].firstElementChild;
              meterImg.setAttribute('src', `img/stories/meter_${meterNo}_sp.png`);
              meterImg.setAttribute('alt', `興奮度${meterNo}%`);
            }
          }
        }
      }, 1500);
    };

    if (optionEl.classList.contains('option-a')) {
      switchSlide('answer-a');
    } else if (optionEl.classList.contains('option-b')) {
      switchSlide('answer-b');
    } else {
      console.log('sorry, tap again');
    }
  };

  // SP版最終ページ表示イベント
  const showEnding = targetEl => {
    const currentAnswerEl = targetEl.parentNode.parentNode;
    const endEl = targetEl.parentNode.parentNode.parentNode.nextElementSibling;
    endEl.classList.add('active');
    currentAnswerEl.classList.add('fadeout');

    // 応募要項オープン
    const accordionBtn = document.getElementById('recruit').getElementsByClassName('btn-accordion')[0];
    accordionBtn.classList.add('fadeout');
    const accordionContainer = accordionBtn.nextElementSibling;

    setTimeout(() => {
      if (!accordionContainer.classList.contains('open')) {
        accordionContainer.classList.add('open')
      }
      currentAnswerEl.style.display = 'none';
    }, 2000);
  }

  // SP版ページングイベント
  const clickSpPaging = e => {
    const targetEl = e.currentTarget;

    switch (targetEl.dataset.paging) {
      case 'start':
        const mvEl = document.getElementById('mv');
        mvEl.classList.add('close');
        setTimeout(() => {
          mvEl.style.display = 'none';
        }, 2000);
        break;
      case 'next-p':
        targetEl.classList.remove('active');
        // next p element
        targetEl.nextElementSibling.classList.add('active');
        break;
      case 'next-page':
        const currentPageDiv = targetEl.parentNode.parentNode;
        currentPageDiv.classList.remove('active');
        currentPageDiv.nextElementSibling.classList.add('active');
        break;
      case 'to-options':
        const qTextEl = targetEl.parentNode;
        qTextEl.classList.remove('active');
        const optionsDiv = qTextEl.nextElementSibling;
        optionsDiv.classList.add('active');
        break;
      case 'next-q':
        const currentAnswerEl = targetEl.parentNode.parentNode;
        currentAnswerEl.classList.remove('active');
        const nextQEl = currentAnswerEl.parentNode.nextElementSibling;
        nextQEl.getElementsByClassName('page1')[0].classList.add('active');
        break;
      case 'end':
        showEnding(targetEl);
        break;
      default:
        console.log('something wrong happened.');
    }
  };

  // after loading
  window.addEventListener('load', () => {
    // for pc options
    const optionList = document.getElementById('stories').getElementsByClassName('visible_pc')[0].getElementsByClassName('option');
    for (let i = 0; i < optionList.length; i++) {
      optionList[i].addEventListener(CLICK_OR_TOUCH_EVENT, clickOption);
    }

    // for sp paging
    document.getElementById('mv').getElementsByClassName('paging')[0].addEventListener(CLICK_OR_TOUCH_EVENT, clickSpPaging);

    const pagingList = document.getElementById('stories').getElementsByClassName('visible_sp')[0].getElementsByClassName('paging');
    for (let i = 0; i < pagingList.length; i++) {
      pagingList[i].addEventListener(CLICK_OR_TOUCH_EVENT, clickSpPaging);
    }

    // for sp options
    const optionSpList = document.getElementById('stories').getElementsByClassName('visible_sp')[0].getElementsByClassName('option');
    for (let i = 0; i < optionSpList.length; i++) {
      optionSpList[i].addEventListener(CLICK_OR_TOUCH_EVENT, clickOptionSp);
    }
  });
}